import React, { useEffect, useState } from "react";
import { characters } from "../data/scenarios";

function DialogBox({ speaker, text, isLoading }) {
  const [displayed, setDisplayed] = useState("");
  const char = characters[speaker];

  useEffect(() => {
    if (!text) return;
    setDisplayed("");
    let i = 0;
    const t = setInterval(() => {
      setDisplayed(text.slice(0, ++i));
      if (i >= text.length) clearInterval(t);
    }, 20);
    return () => clearInterval(t);
  }, [text]);

  return (
    <>
      <div className="vn-speaker" style={{ color: char?.color || "#aaa" }}>
        {char?.name || speaker}
      </div>
      <div className="vn-text">
        {isLoading ? (
          <span className="vn-loading">L'IA génère le dialogue...</span>
        ) : (
          displayed
        )}
      </div>
    </>
  );
}

export default DialogBox;
